export enum CPMMState {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
}
